﻿import {NamedValue, StringNamedValue} from "@2d-front-monorepo/core";
import {useMemo} from "react";

export function useItemMap<TValue>(items: NamedValue<TValue>[]): StringNamedValue[] {
	return useMemo<StringNamedValue[]>(() => items.map((x, index) => ({
		value: index.toString(),
		label: x.label
	})), [items]);
}
